'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixNamespace;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixNamespace(model, sep) {
  var namespace = model.namespace,
      reducers = model.reducers;
  // For HMR. 不能重复Prefix执行

  var modelCopy = Object.assign({}, model);

  if (reducers) {
    if (Array.isArray(reducers)) {
      modelCopy.reducers[0] = prefix(reducers[0], namespace, sep, 'reducer');
    } else {
      modelCopy.reducers = prefix(reducers, namespace, sep, 'reducer');
    }
  }
  return modelCopy;
}

function prefix(obj, namespace, sep, type) {
  return Object.keys(obj).reduce(function (memo, key) {
    (0, _warning2.default)(key.indexOf('' + namespace + sep) !== 0, '[prefixNamespace]: ' + type + ' ' + key + ' should not be prefixed with namespace ' + namespace);
    var newKey = '' + namespace + sep + key;
    memo[newKey] = obj[key];
    return memo;
  }, {});
}